import { useContext } from "react";
import NotyfContext from "../../../../../contexts/NotyfContext";
import useSignFormResources from "./useSignFormResources";
import useStudentResource from "../../../BcaAttendance/hooks/useStudentResource";
import handleSignatureSubmit from "../../../BcaAttendance/hooks/handleSignatureSubmit";


export default function useSignFormLogic(id) {
    const resources = useSignFormResources({id});
    const notyf = useContext(NotyfContext);
    // const studentResource = useStudentResource({id: null}) // student 
    
    

    return {
        ...resources,
        // ...studentResource,
        notyf
    };
}